export default "__VITE_ASSET__ByKGo3Wi__"